<template>
  <div class="d-flex justify-content-end m-3">
    <v-btn
      class="m-1 reset-btn"
      :disabled="running"
      @click="cancel"
    >
      {{ i18n.global.t('pages.common.button.close') }}
    </v-btn>
    <v-btn
      v-show="isUpdateAuthority"
      class="m-1 exec-btn"
      @click="submit"
      :loading="running"
    >
      {{ i18n.global.t('pages.common.button.conservation') }}
    </v-btn>
  </div>
</template>

<script>
import i18n from '@/lang/i18n';

export default {
  setup() {
    return {
      i18n
    }
  },
  props: {
    items: [],
    hasError: {
      type: Boolean,
      default: false,
    },
    running: {
      type: Boolean,
      default: false,
    },
    isUpdateAuthority: {
      type: Boolean,
    }
  },
  data() {
    return {
    }
  },
  methods: {
    submit() {
      if (!this.hasError) {
        this.$emit('submit', this.items)
      }
    },
    cancel() {
      this.$emit('cancel')
    },
  },
  components: {
  },
}
</script>

<style>
.v-btn--disabled.v-btn--variant-contained {
  color:inherit;
  box-shadow: inherit;
  background: rgb(21, 130, 156) !important;
}
</style>
